import Swiper from 'swiper/dist/js/swiper.js';
var WheelIndicator = require('wheel-indicator');

var homepage = {
    swiper: {
        instance: null,
        containerClass: '.swiper-container-homepage',
        breakpoint: 991,
        
        params: {
            direction: 'horizontal',
            spaceBetween: 0,
            mousewheel: false,
            grabCursor: true,
            speed: 600,
            threshold: 10,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            autoplay: {
                delay: 6000,
                stopOnLastSlide: true,
                disableOnInteraction: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            on: {
                init: function() {
                    var activeSlide  = this.slides.eq(this.activeIndex);
                },

                slideChangeTransitionStart: function() {
                    $('body').addClass('slide-transitioning');
                },

                slideChangeTransitionEnd: function() {
                    var activeSlide  = this.slides.eq(this.activeIndex);
                    $('body').removeClass('slide-transitioning');
                },

                slideChange: function() {
                    var activeSlide  = this.slides.eq(this.activeIndex);
                    homepage.helpers.hashNavigation.setHashBySlide(activeSlide);
                    homepage.slides.onEnter(activeSlide);
                }
            }
        },

        init: function() {
            this.params.direction = window.innerWidth <= this.breakpoint ? 'vertical' : 'horizontal';
            this.instance = new Swiper(this.containerClass, this.params);
            this.setEventListeners();
            return this.instance;
        },

        setEventListeners: function() {
            window.addEventListener("orientationchange", window.debounce(homepage.swiper.resize));
            window.addEventListener("resize", window.debounce(homepage.swiper.resize));
        },

        resize: function() {
            homepage.swiper.params.direction = window.innerWidth <= homepage.swiper.breakpoint ? 'vertical' : 'horizontal';
            
            if (homepage.swiper.instance.destroyed) {
                homepage.swiper.init();
                return;
            }
            
            if (homepage.swiper.params.direction != homepage.swiper.instance.params.direction) {
                homepage.swiper.reinit();
                return;
            }
        },

        reinit: function() {
            this.instance.destroy(true);
            this.init(true);
            homepage.helpers.hashNavigation.onHashCange();
        }
    },
    slides: {
        onEnter: function(slide) {
            this.onLeave();

            switch (homepage.helpers.hashNavigation.getHashFromSlide(slide)) {
                case "in-our-factory-we-create":
                    this.inOurFactory.onEnter();
                    break;
                case "until-the-job-is-done":
                    this.untilTheJobIsDone.onEnter();
                    break;
                case "together":
                    this.together.onEnter();
                    break;
            }
        },

        onLeave: function() {
            this.inOurFactory.onLeave();
            this.untilTheJobIsDone.onLeave();
            this.together.onLeave();
        },

        inOurFactory: {
            animationFrameId: null,
            animationFrameTimeWhenLastUpdate: null,
            animationFrameTimeFromLastUpdate: null,
            animationImageElement: null,
            animationImages: null,
            animationFrameNumber: 1,

            onEnter: function() {
                this.animateImageStart();
            },

            onLeave: function() {
                this.animateImageStop();
            },

            animateImage: function(startTime) {
                var inOurFactory = homepage.slides.inOurFactory;
                var duration = 800; 

                if (inOurFactory.animationFrameTimeWhenLastUpdate == null) { 
                    inOurFactory.animationFrameTimeWhenLastUpdate = startTime
                }

                inOurFactory.animationFrameTimeFromLastUpdate = startTime - inOurFactory.animationFrameTimeWhenLastUpdate;

                if (inOurFactory.animationFrameTimeFromLastUpdate > duration)
                {
                    var image = inOurFactory.animationImages[inOurFactory.animationFrameNumber - 1];
                    inOurFactory.animationImageElement.attr('src', image.trim());
                    inOurFactory.animationFrameTimeWhenLastUpdate = startTime;

                    if (inOurFactory.animationFrameNumber >= inOurFactory.animationImages.length) {
                        inOurFactory.animationFrameNumber = 1;
                    } else {
                        inOurFactory.animationFrameNumber = inOurFactory.animationFrameNumber + 1;
                    }        
                }

                inOurFactory.animationFrameId = window.requestAnimationFrame(inOurFactory.animateImage);

            },

            animateImageStart: function() {
                this.animationImageElement = $('#inOurFactoryWeCreateImage');
                var dataImages = this.animationImageElement.data('images');
                this.animationImages = dataImages.split(',');

                this.animationFrameId = window.requestAnimationFrame(this.animateImage);
            },

            animateImageStop: function() {
                window.cancelAnimationFrame(this.animationFrameId);
            }
        },

        untilTheJobIsDone: {
            
            youtubePlayer: null,
            
            vimeoPlayer: null,

            loadVimeoPlayer: function() {                
                  this.vimeoPlayer = new Vimeo.Player($('#vimeoPlayer')[0]);
            },

            onYouTubeIframeAPIReady: function(videoId) {
                this.youtubePlayer = new YT.Player('youtubePlayer', {
                    videoId: videoId,
                    width: 1109,
                    height: 624,
                    playerVars: {
                        autoplay: 0,
                        controls: 0,
                        showinfo: 0,
                        modestbranding: 1,
                        loop: 1,
                        fs: 0,
                        cc_load_policy: 0,
                        iv_load_policy: 3,
                        autohide: 0,
                        mute: 0,
                        playsinline: 1,
                        rel: 0,
                    },
                    events: {
                        onReady: function(e) {
                            e.target.playVideo();
                            e.target.mute();
                        },
                        onStateChange: function(e) {
                            if (e.data === YT.PlayerState.ENDED) {
                                e.target.playVideo(); 
                            }
        
                            e.target.mute();
                        }
                    }
                });
            },

            onEnter: function() {
                if (this.vimeoPlayer != null) {
                    this.vimeoPlayer.play();
                }
            },

            onLeave: function() {
                if (this.vimeoPlayer != null) {
                    this.vimeoPlayer.pause();
                }
            }
        },

        together: {
            animationFrameId: null,
            animationFrameTimeWhenLastUpdate: null,
            animationFrameTimeFromLastUpdate: null,
            animationImageElement: null,
            animationImages: null,
            animationFrameNumber: 1,

            onEnter: function() {
                this.animateImageStart();
            },

            onLeave: function() {
                this.animateImageStop();
            },

            animateImage: function(startTime) {
                var slide = homepage.slides.together;
                var duration = 800; 

                if (slide.animationFrameTimeWhenLastUpdate == null) { 
                    slide.animationFrameTimeWhenLastUpdate = startTime
                }

                slide.animationFrameTimeFromLastUpdate = startTime - slide.animationFrameTimeWhenLastUpdate;

                if (slide.animationFrameTimeFromLastUpdate > duration)
                {
                    var image = slide.animationImages[slide.animationFrameNumber - 1];
                    slide.animationImageElement.attr('src', image.trim());
                    slide.animationFrameTimeWhenLastUpdate = startTime;

                    if (slide.animationFrameNumber >= slide.animationImages.length) {
                        slide.animationFrameNumber = 1;
                    } else {
                        slide.animationFrameNumber = slide.animationFrameNumber + 1;
                    }        
                }

                slide.animationFrameId = window.requestAnimationFrame(slide.animateImage);

            },

            animateImageStart: function() {
                this.animationImageElement = $('#togetherImage');
                var dataImages = this.animationImageElement.data('images');
                this.animationImages = dataImages.split(',');

                this.animationFrameId = window.requestAnimationFrame(this.animateImage);
            },

            animateImageStop: function() {
                window.cancelAnimationFrame(this.animationFrameId);
            }
        }

    },
    helpers: {
        scrollWheel: {
            init: function() {
                window.debounce(new WheelIndicator({
                    elem: $(homepage.swiper.containerClass)[0],
                    callback: function(e){
                        if(e.direction == 'up') {
                            homepage.swiper.instance.slidePrev();
                        } else {
                            homepage.swiper.instance.slideNext();
                        }
                    }
                }), 100);
            }
        },

        hashNavigation: {

            defaultHash: 'hi',

            init: function() {
                var hash = this.getHash();
                this.setActiveSlideByHash(hash);
                $(window).on('hashchange', homepage.helpers.hashNavigation.onHashCange);
            },

            onSlideChange: function(slide) {
                var hash = this.getHashFromSlide(slide);

                this.setHash(this.getHashFromSlide(slide));
            },

            setHash: function(hash) {
                document.location.hash = hash || '';
                
                $('body').removeClass(function (index, css) {
                    return (css.match (/\bactive-slide-\S+/g) || []).join(' ');
                    // removes anything that starts with "active-slide-"
                });

                $('body').addClass('active-slide-' + hash);
            },

            setHashBySlide: function(slide) {
                var hash = this.getHashFromSlide(slide);
                this.setHash(hash);
            },

            getHash: function() {
                var hash = document.location.hash.replace('#', '');
                return hash;
            },

            getHashFromSlide: function(slide) {
                var hash = slide.attr('data-slide');
                return hash;
            },

            onHashCange: function() {
                homepage.helpers.hashNavigation.setActiveSlideByHash(homepage.helpers.hashNavigation.getHash());
            },

            setActiveSlideByHash: function(hash) {
                var hash = hash != '' ? hash : this.defaultHash;
                this.setActiveSlideByHashAndSwiper(hash, homepage.swiper.instance);
            },

            setActiveSlideByHashAndSwiper(hash, swiper) {
                var currentActiveSlide = swiper.slides.eq(swiper.activeIndex);
                var currentActiveSlideHash = this.getHashFromSlide(currentActiveSlide);

                if (hash != currentActiveSlideHash) {
                    var newSlide = swiper.$wrapperEl.children(("." + (swiper.params.slideClass) + "[data-slide=\"" + hash + "\"]"));
                    swiper.slideTo(newSlide.index(), 1200);
                }
            }
        }
    }
}

homepage.swiper.init();
homepage.helpers.scrollWheel.init();
homepage.helpers.hashNavigation.init();

window.homepage = homepage;